import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../environments/environment';
import { Bacino } from '../models/bacino.model';

@Injectable({
  providedIn: 'root'
})
export class BaciniService {
  private apiUrl = environment.apiUrl + "/bacino"; // URL base per le API dei comuni

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) { }


  getBacini(): Observable<Bacino[]> {
    const url = `${this.apiUrl}`;

    return this.http.get<Bacino[]>(url);
  }

  getBaciniByEnteEsecutore(): Observable<Bacino[]> {
    const enteId = localStorage.getItem("enteId") || '';
    const url = `${this.apiUrl}?enteEsecutore=${enteId}`;
    return this.http.get<Bacino[]>(url);
  }

  getConfini(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/confini`);
  }

}
